import { FaBitcoin } from "react-icons/fa";
import { FaEthereum } from "react-icons/fa";
import {
  FaCoins,
  FaDollarSign,
  FaCreativeCommonsPdAlt,
  FaLemon,
  FaMoneyBill,
  FaMoneyBillWave,
} from "react-icons/fa";

const cryptoIcons = [
  {
    id: 1,
    icon: <FaBitcoin />,
  },
  {
    id: 2,
    icon: <FaEthereum />,
  },
  {
    id: 3,
    icon: <FaDollarSign />,
  },
  {
    id: 4,
    icon: <FaMoneyBillWave />,
  },
  {
    id: 5,
    icon: <FaCreativeCommonsPdAlt />,
  },
  {
    id: 6,
    icon: <FaMoneyBill />,
  },
  {
    id: 7,
    icon: <FaLemon />,
  },
  {
    id: 8,
    icon: <FaCoins />,
  },
];
export default cryptoIcons;
